import * as React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

export const AutocompleteStationListPop = styled(({ className, ...props }) => (
    <Tooltip placement='right' {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0)',
        boxShadow: theme.shadows[1],
        fontSize: 13,
        fontWeight: 600
    },
}));
